import { Component } from '@angular/core';
import {
    FieldType,
    FormlyExtension,
    FormlyFieldConfig
} from '@ngx-formly/core';
import {
    sharedHealthCondition,
    sharedHealthInsurer,
    sharedRetirement
} from '../../form-parts-definition';

@Component({
  selector: 'tpa-health',
  templateUrl: './health.component.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'tpa-wrapper__control' },
})
export class HealthComponent extends FieldType implements FormlyExtension {
  defaultOptions = {
    className: 'p-col-12',
    props: {
      translate: true,
      open: false,
    },
  };

  onPopulate(field: FormlyFieldConfig) {
    if (field.fieldGroup) {
      return;
    }

    field.fieldGroup = [
      ...sharedHealthInsurer(),
      ...sharedHealthCondition(),
      sharedRetirement(),
    ];
  }
}
